import request from '@/utils/request'

export function selectVideoInfo () {
  return request({
    url: '/api/videoplay/' + sessionStorage.getItem('videoId') + '?uuid=1',
    method: 'get'
  })
}
export function playggimg () {
  return request({
    url: '/api/adinfo/PLAYBEFORE',
    method: 'get'
  })
}
export function conterggimg () {
  return request({
    url: '/api/adinfo/PLAYINFO',
    method: 'get'
  })
}
export function getLikeList (data) {
  return request({
    url: '/api/videomaylike',
    method: 'get',
    params: data
  })
}

export function getVideoTopic (labelId) {
  return request({
    url: `/api/videotopic/${labelId}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/API/playVideo.js